import { cn } from '../../lib/utils';

function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn('animate-pulse rounded-lg bg-background-tertiary', className)}
      {...props}
    />
  );
}

export { Skeleton };
